import { Box, Typography } from '@mui/material';
import i18n from 'i18';
import { styled } from '@mui/system';
import { fNumber } from '../../../../../../../utils/formatNumber';

const PillCard = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderRadius: '24px',
    padding: '8px 16px',
    backgroundColor: theme.palette.background.default,
    border: `1px solid ${theme.palette.grey[300]}`,
    boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.1)',
    gap: '18px'
}));

export const TotalItemsField = ({ field, additionalData }) => {
    const { label, pillLabel, keyAnotherField } = field;
    const getTotalItems = (value, key) => {
        if (!value || !value.length) {
            return 0;
        }
        return value.reduce((acc, item) => {
            return acc + item[key];
        }, 0);
    };
    const totalItems = getTotalItems(additionalData, keyAnotherField);
    const translatedLabel = i18n.t(`columns.${label}`);
    const translatedPillLabel = i18n.t(`columns.${pillLabel}`);
    return (
        <Box
            sx={{
                mb: 2,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
            }}
        >
            <Typography variant={'h5'}>{translatedLabel}</Typography>
            <PillCard>
                {/* Label section */}
                <Typography
                    variant="body2"
                    sx={{
                        color: (theme) => theme.palette.text.secondary,
                        fontWeight: 500
                    }}
                >
                    {translatedPillLabel}
                </Typography>
                {/* Value section */}
                <Typography
                    variant="button"
                    sx={{
                        color: (theme) => theme.palette.text.primary,
                        fontWeight: 600
                    }}
                >
                    {fNumber(totalItems)}
                </Typography>
            </PillCard>
        </Box>
    );
};
